import dayjs from "dayjs"
import { numberFormat } from "utils"

// Top-right block of a payslip: month, driver, and the running หักเงินประกัน balance.
// Shared by the V3 payslip (printDriverSalaryV3Summary).
export const printDriverSalaryTopRight = ({ doc, dialogData, startY, lineHeight, contentSize, page, totalPage }) => {
  let yPos = startY
  doc.setFont("THSarabun", "bold")
  doc.setFontSize(20)
  doc.text("รายละเอียดเงินเดือน", 7, yPos, { align: "center" })

  doc.setFont("THSarabun", "bold")
  doc.setFontSize(contentSize)
  const lineHeightTopRight = lineHeight
  const yPosTopRight = yPos + lineHeightTopRight
  const xPosTopRight = 5.6
  let xPos = xPosTopRight
  yPos = yPosTopRight

  doc.text("ประจำเดือน : ", xPos, yPos)
  yPos += lineHeightTopRight
  doc.text("พนักงาน: ", xPos, yPos)
  yPos += lineHeightTopRight
  // the ÷500 unit count is appended by the V3 payslip (undefined elsewhere -> label unchanged)
  doc.text(`หักเงินประกันสะสม${dialogData.AccuSecDepCnt != null ? `(${dialogData.AccuSecDepCnt})` : ""}: `, xPos, yPos)
  doc.setFont("THSarabun", "normal")

  yPos = yPosTopRight
  xPos += 0.8
  doc.text(dayjs(dialogData.SalDte).format("MMMM YYYY"), xPos, yPos)
  yPos += lineHeightTopRight
  doc.setFontSize(contentSize + 3)
  doc.text(`${dialogData.DrvNm} (${dialogData.DrvCd || "-"})`, xPos - 0.2, yPos)
  yPos += lineHeightTopRight
  doc.text(`${numberFormat(dialogData.AccuDeSecDepAmnt)} บาท`, xPos + 1.4, yPos, { align: "right" })
  doc.setFontSize(contentSize)
  if (totalPage > 1) {
    yPos += lineHeightTopRight
    doc.text(`(หน้า ${page} / ${totalPage})`, xPosTopRight, yPos)
  }
  return yPos
}
